
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AccessibilityProvider } from "@/hooks/useAccessibility";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import ComunicacaoPage from "./pages/recursos/Comunicacao";
import DesenhoIAPage from "./pages/recursos/DesenhoIA";
import RotinasPage from "./pages/recursos/Rotinas";
import JogosPage from "./pages/recursos/Jogos";
import MusicaPage from "./pages/recursos/Musica";
import ProgressoPage from "./pages/recursos/Progresso";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import FaleConosco from "./pages/FaleConosco";
import Equipe from "./pages/Equipe";
import FAQ from "./pages/FAQ";
import Suporte from "./pages/Suporte";
import Login from "./pages/Login";
import RedefinirSenha from "./pages/RedefinirSenha";
import Dashboard from "./pages/Dashboard";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AccessibilityProvider>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              {/* Não existe mais uma página de listagem — "Recursos" agora é o dropdown do nav.
                  /recursos sozinho reencaminha pro primeiro recurso, pra não quebrar links antigos. */}
              <Route path="/recursos" element={<Navigate to="/recursos/comunicacao" replace />} />
              <Route path="/recursos/comunicacao" element={<ComunicacaoPage />} />
              <Route path="/recursos/desenho-ia" element={<DesenhoIAPage />} />
              <Route path="/recursos/rotinas" element={<RotinasPage />} />
              <Route path="/recursos/jogos" element={<JogosPage />} />
              <Route path="/recursos/musica" element={<MusicaPage />} />
              <Route path="/recursos/progresso" element={<ProgressoPage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contato" element={<FaleConosco />} />
              <Route path="/equipe" element={<Equipe />} />
              {/* /sobre virou /equipe (página reformulada) — redirect pra não quebrar links antigos. */}
              <Route path="/sobre" element={<Navigate to="/equipe" replace />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/suporte" element={<Suporte />} />
              <Route path="/login" element={<Login />} />
              <Route path="/redefinir-senha" element={<RedefinirSenha />} />
              <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
    </AccessibilityProvider>
  </QueryClientProvider>
);

export default App;
